import classNames from 'classnames';
import React from 'react';
import { conditionCodeToName } from '../../../../common/src/condition/conditionCodeToName';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface IConditionDotProps extends ITranslateProps {
    value?: any;
}

class ConditionDotComponent extends React.Component<IConditionDotProps, Record<string, unknown>> {
    public override render() {
        if (!this.props.value) {
            return null;
        }
        const name = conditionCodeToName(this.props.value.toString());
        const text = this.props.t(`condition.${name}`);
        const classObject = {
            fa: true,
            'fa-square': this.props.value !== 'U',
            'fa-square-o': this.props.value === 'U',
            fs16: true,
            ml20: true,
        } as any;
        classObject[`icon-${name}`] = true;

        return <span className={classNames(classObject)} title={text}></span>;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const ConditionDot = translate()(ConditionDotComponent);
export { ConditionDot };
